<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
      <v-toolbar-title> {{ 'app.import_schema_into_patient.dialog_header' | trans }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon dark small @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="bg-white">
          <v-flex>
            <patients-table-in-components ref="patientsTable" @patientSelected="patientSelected"></patients-table-in-components>
          </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {trans} from "../../app";

export default {
  data: function () {
    return {
      dialog: false,
      patient: null,
      schemaId: null,
      desiredDietEnergy: null,
    };
  },
  methods: {
    open: function (schemaId, desiredDietEnergy) {
      this.schemaId = schemaId;
      this.desiredDietEnergy = desiredDietEnergy;
      this.dialog = true;
    },
    close: function () {
      this.schemaId = null;
      this.desiredDietEnergy = null;
      this.dialog = false;
      this.$refs.patientsTable.close();
    },
    patientSelected: function (patient) {
      this.patient = !!patient ? patient : null;
      this.save();
    },
    save: async function () {
      this.$dialog.confirm(trans('app.menu.willing_to_scale'))
          .then(() => {
            this.$emit('schemaSelected', {
              patient_id: this.patient.id,
              schema_id: this.schemaId,
              desiredDietEnergy: this.desiredDietEnergy,
            });
            this.close();
          })
          .catch(() => {
            this.importSchema();
          })
    },
    importSchema: function() {
        axios.post(`/schemas/${this.patient.id}/import`, {
          schema: this.schemaId,
          scale_products: false,
        }).then((response) => {
          window.location = response.data.url;
        }).catch(() => {
          this.$toast.error(trans('app.import_schema_into_patient.operation_failed'));
          this.clearStatus();
        })
    },
    clearStatus: function () {
      this.close();
      this.$refs.patientsTable.close();
    }
  },
  watch: {
    dialog() {
      if (this.dialog === false) {
        this.close();
      }
    }
  }
}
</script>
<style scoped>
.bg-white {
  background-color: white;
}
</style>
